<template src="./html/Datatable.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import Create from './Create'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'
	
	export default {
		props: ['user', 'isAuth', 'customer'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'create': Create,
			'loading': VueElementLoading,
		},
		created() {
			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/cms/articles/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							lang_code: this.$lang.getLang(),
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: '__slot:category',
							title: 'Categoría',
						},
						{
							name: '__slot:status',
							title: 'Estado',
							sortField: 'status_id',
						},
						{
							name: '__slot:author',
							title: 'Autor',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							callback: function(value) {
								return moment(value).format('H:mm DD/MM/YY')
							},
							sortField: 'created_at',
						},
						{
							name: '__slot:actions',
							title: '',
						}
					],
				},

				statuses: null,
			}
		},
		methods: {
			init() {
				this.getStatuses()
			},
			getStatuses() {
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.lang_code = this.$lang.getLang(),
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				this.$router.replace({'query': null})
			},
			//--
			activate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/cms/articles/' + item.id + '/activate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.item.status_id = data.item.status_id
						item.item.status = data.item.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			deActivate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/cms/articles/' + item.id + '/deactivate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.item.status_id = data.item.status_id
						item.item.status = data.item.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			destroy: function(category) {
				var html = this.$t("messages.item_can_not_be_retrieved")
				if(category.sub_categories_count > 1) {
					var html = html + '<br><br><h3>La categoría <b>' + category.title +'</b> tiene ' + category.sub_categories_count + ' subcategorías, también serán borradas.</h3>'
				}
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					html: html,
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/cms/articles/' + category.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/Datatable.vue